var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "content-header row" }, [
      _c("div", { staticClass: "content-header-left col-md-7 col-12 mb-2" }, [
        _c("div", { staticClass: "row breadcrumbs-top" }, [
          _c("div", { staticClass: "col-12" }, [
            _c("h2", { staticClass: "content-header-title float-left mb-0" }, [
              _vm._v(
                _vm._s(_vm.trans("clearance.clearance")) +
                  "\n                     "
              )
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "breadcrumb-wrapper col-12" }, [
              _c("ol", { staticClass: "breadcrumb" }, [
                _c(
                  "li",
                  { staticClass: "breadcrumb-item" },
                  [
                    _c("router-link", { attrs: { to: "/home" } }, [
                      _vm._v(
                        "\n                                     " +
                          _vm._s(_vm.trans("general.home")) +
                          "\n                                 "
                      )
                    ])
                  ],
                  1
                ),
                _vm._v(" "),
                _c("li", { staticClass: "breadcrumb-item active" }, [
                  _vm._v(
                    "\n                                 " +
                      _vm._s(_vm.trans("clearance.clearance")) +
                      "\n                             "
                  )
                ])
              ])
            ])
          ])
        ])
      ]),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass:
            "content-header-right text-md-right col-md-5 col-12 d-md-block d-none"
        },
        [
          _c("div", { staticClass: "form-group breadcrum-right" }, [
            _c(
              "button",
              {
                staticClass: "btn btn-primary btn-sm pull-right ml-1",
                on: {
                  click: function($event) {
                    return _vm.$router.push("/clearance/generate")
                  }
                }
              },
              [
                _c("i", { staticClass: "feather icon-plus" }),
                _vm._v(" " + _vm._s(_vm.trans("clearance.create_clearance")))
              ]
            )
          ])
        ]
      )
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "content-body" }, [
      _c("section", { attrs: { id: "basic-datatable" } }, [
        _c("div", { staticClass: "row" }, [
          _c("div", { staticClass: "col-12" }, [
            _c("div", { staticClass: "card" }, [
              _c("div", { staticClass: "card-header" }, [
                _vm.clearances.total
                  ? _c(
                      "h4",
                      { staticClass: "card-title" },
                      [
                        _c("sort-by", {
                          attrs: {
                            "order-by-options": _vm.orderByOptions,
                            "sort-by": _vm.filterClearanceForm.sort_by,
                            order: _vm.filterClearanceForm.order
                          },
                          on: {
                            updateSortBy: function(value) {
                              _vm.filterClearanceForm.sort_by = value
                            },
                            updateOrder: function(value) {
                              _vm.filterClearanceForm.order = value
                            }
                          }
                        })
                      ],
                      1
                    )
                  : _vm._e()
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "card-content" }, [
                _c(
                  "div",
                  { staticClass: "card-body" },
                  [
                    _vm.clearances.total
                      ? _c("div", { staticClass: "table-responsive" }, [
                          _c("table", { staticClass: "table" }, [
                            _c("thead", [
                              _c("tr", [
                                _c("th", [
                                  _vm._v(
                                    _vm._s(_vm.trans("general.serial_number"))
                                  )
                                ]),
                                _vm._v(" "),
                                _c("th", [
                                  _vm._v(_vm._s(_vm.trans("clearance.mda")))
                                ]),
                                _vm._v(" "),
                                _c("th", [
                                  _vm._v(_vm._s(_vm.trans("clearance.month")))
                                ]),
                                _vm._v(" "),
                                _c("th", [
                                  _vm._v(_vm._s(_vm.trans("clearance.year")))
                                ]),
                                _vm._v(" "),
                                _c("th", [
                                  _vm._v(
                                    _vm._s(_vm.trans("clearance.online_amount"))
                                  )
                                ]),
                                _vm._v(" "),
                                _c("th", [
                                  _vm._v(
                                    _vm._s(
                                      _vm.trans("clearance.receipt_amount")
                                    )
                                  )
                                ]),
                                _vm._v(" "),
                                _c("th", [
                                  _vm._v(
                                    _vm._s(_vm.trans("clearance.mla_amount"))
                                  )
                                ]),
                                _vm._v(" "),
                                _c("th", [
                                  _vm._v(
                                    _vm._s(
                                      _vm.trans("clearance.institution_amount")
                                    )
                                  )
                                ]),
                                _vm._v(" "),
                                _c("th", [
                                  _vm._v(_vm._s(_vm.trans("general.status")))
                                ]),
                                _vm._v(" "),
                                _c("th", { staticClass: "table-option" }, [
                                  _vm._v(_vm._s(_vm.trans("general.action")))
                                ])
                              ])
                            ]),
                            _vm._v(" "),
                            _c(
                              "tbody",
                              _vm._l(_vm.clearances.data, function(
                                clearance,
                                index
                              ) {
                                return _c("tr", [
                                  _c("td", {
                                    domProps: { textContent: _vm._s(index + 1) }
                                  }),
                                  _vm._v(" "),
                                  _c("td", {
                                    domProps: {
                                      textContent: _vm._s(clearance.mda.name)
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c("td", {
                                    domProps: {
                                      innerHTML: _vm._s(
                                        _vm.getMonthName(clearance.month)
                                      )
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c("td", {
                                    domProps: {
                                      textContent: _vm._s(clearance.year)
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c("td", [
                                    _vm._v(
                                      _vm._s(
                                        _vm._f("formatMoney")(
                                          clearance.online_payments_amount
                                        )
                                      )
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _c("td", [
                                    _vm._v(
                                      _vm._s(
                                        _vm._f("formatMoney")(
                                          clearance.manual_payments_amount
                                        )
                                      )
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _c("td", [
                                    _vm._v(
                                      _vm._s(
                                        _vm._f("formatMoney")(
                                          clearance.mla_payments_amount
                                        )
                                      )
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _c("td", [
                                    _vm._v(
                                      _vm._s(
                                        _vm._f("formatMoney")(
                                          clearance.institutions_payments_amount
                                        )
                                      )
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _c("td", {
                                    domProps: {
                                      innerHTML: _vm._s(
                                        _vm.getStatus(clearance)
                                      )
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c("td", { staticClass: "table-option" }, [
                                    _c("div", { staticClass: "btn-group" }, [
                                      _c(
                                        "button",
                                        {
                                          directives: [
                                            {
                                              name: "tooltip",
                                              rawName: "v-tooltip",
                                              value: clearance.status
                                                ? _vm.trans("clearance.reject")
                                                : _vm.trans(
                                                    "clearance.approve"
                                                  ),
                                              expression:
                                                "clearance.status ? trans('clearance.reject') : trans('clearance.approve')"
                                            }
                                          ],
                                          staticClass: "btn btn-primary btn-sm",
                                          on: {
                                            click: function($event) {
                                              $event.preventDefault()
                                              return _vm.toggleStatus(clearance)
                                            }
                                          }
                                        },
                                        [
                                          _c("i", {
                                            class: [
                                              "feather",
                                              clearance.status
                                                ? "icon-x"
                                                : "icon-check"
                                            ]
                                          })
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "a",
                                        {
                                          directives: [
                                            {
                                              name: "tooltip",
                                              rawName: "v-tooltip",
                                              value: _vm.trans("general.print"),
                                              expression:
                                                "trans('general.print')"
                                            }
                                          ],
                                          staticClass: "btn btn-success btn-sm",
                                          attrs: {
                                            href:
                                              "/clearance/" +
                                              clearance.reference_no +
                                              "/print",
                                            target: "_blank"
                                          }
                                        },
                                        [
                                          _c("i", {
                                            staticClass: "feather icon-printer"
                                          })
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "button",
                                        {
                                          directives: [
                                            {
                                              name: "confirm",
                                              rawName: "v-confirm",
                                              value: {
                                                ok: _vm.confirmDelete(clearance)
                                              },
                                              expression:
                                                "{ok: confirmDelete(clearance)}"
                                            },
                                            {
                                              name: "tooltip",
                                              rawName: "v-tooltip",
                                              value: _vm.trans(
                                                "clearance.delete-clearance"
                                              ),
                                              expression:
                                                "trans('clearance.delete-clearance')"
                                            }
                                          ],
                                          key: clearance.id,
                                          staticClass: "btn btn-danger btn-sm"
                                        },
                                        [
                                          _c("i", {
                                            staticClass: "feather icon-trash-2"
                                          })
                                        ]
                                      )
                                    ])
                                  ])
                                ])
                              }),
                              0
                            )
                          ])
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    !_vm.clearances.total
                      ? _c(
                          "module-info",
                          {
                            attrs: {
                              module: "clearance",
                              title: "module_info_title",
                              description: "module_info_description",
                              icon: "check-circle"
                            }
                          },
                          [
                            _c("div", { attrs: { slot: "btn" }, slot: "btn" }, [
                              _c(
                                "button",
                                {
                                  staticClass: "btn btn-primary btn-md",
                                  on: {
                                    click: function($event) {
                                      return _vm.$router.push(
                                        "/clearance/generate"
                                      )
                                    }
                                  }
                                },
                                [
                                  _c("i", { staticClass: "feather icon-plus" }),
                                  _vm._v(
                                    " " + _vm._s(_vm.trans("general.add_new"))
                                  )
                                ]
                              )
                            ])
                          ]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _c("pagination-record", {
                      attrs: {
                        "page-length": _vm.filterClearanceForm.page_length,
                        records: _vm.clearances
                      },
                      on: {
                        "update:pageLength": function($event) {
                          return _vm.$set(
                            _vm.filterClearanceForm,
                            "page_length",
                            $event
                          )
                        },
                        "update:page-length": function($event) {
                          return _vm.$set(
                            _vm.filterClearanceForm,
                            "page_length",
                            $event
                          )
                        },
                        updateRecords: _vm.getClearances
                      }
                    })
                  ],
                  1
                )
              ])
            ])
          ])
        ])
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }